import { CardBody } from '@statsbomb/kitbag-components';
import { PrimitiveAtom } from 'jotai';
import { useHydrateAtoms } from 'jotai/utils';
import { itemsPerPageAtom } from '@/atoms/pagination';
import { tableColumnEntitiesAtom } from '@/atoms/queries/tableColumns';
import { visibleTableColumnsAtom } from '@/atoms/table';
import { CardHeightWrapper } from '@/components/card/CardHeightWrapper';
import { TeamSquadTable } from '@/components/tables/TeamSquadTable';
import { MINUTES_PLAYED_COLUMN } from '@/consts/dataLocker/table';
import { ALL_ITEMS } from '@/consts/interface';

// A "lighter" version of the regular team squad page table component for displaying on the team dashboard.
export const TeamDashboardSquadTable = () => {
  useHydrateAtoms([
    [tableColumnEntitiesAtom, ['player', 'player_metric']],
    [visibleTableColumnsAtom, ['playerLink', 'player.age', MINUTES_PLAYED_COLUMN]],
    [itemsPerPageAtom, ALL_ITEMS],
  ] as [PrimitiveAtom<unknown>, unknown][]);

  return (
    <CardHeightWrapper>
      <CardBody>
        {/* Inline stying change reverted to resolve issue with card height on production. Needs handing in component library */}
        <div className="max-h-80 overflow-auto [&>div]:m-0">
          <TeamSquadTable />
        </div>
      </CardBody>
    </CardHeightWrapper>
  );
};
